// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"9f16fd93a199eb94","src_app_bulk-user-update_bulk-user-update_module_ts":"aefdf95ad60ad319"}[chunkId] + ".js";
};